import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('MAIN_PROVIDER', ['MODAL_FORM', 'LIST_FORM'])
